class SortContainer extends HTMLElement {
  constructor() {
    super();
  }

  get sectionId() {
    return this.dataset.sectionId;
  }

  connectedCallback() {
    this.inputs = this.querySelectorAll('input[name="sort-by"]');
    this.handleSort = this.handleSort.bind(this);

    this.inputs.forEach(input => {
      input.addEventListener('input', this.handleSort);
    })
  }

  disconnectedCallback() {
    this.inputs.forEach(input => {
      input.removeEventListener('input', this.handleSort);
    })
  }

  handleSort(event) {
    const input = event.currentTarget;
    if (input.checked) {

      const sortParam = input.value;
      const url = new URL(window.location.href);

      // update the Search parameters
      url.searchParams.set('sort_by', sortParam);
      url.searchParams.set("section_id", this.sectionId);

      fetch(url.toString())
        .then(response => {
          return response.text();
        })
        .then(html => {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;

          document.querySelector('#collection-main').innerHTML = tempDiv.querySelector('#collection-main').innerHTML;

          url.searchParams.delete('section_id');
          window.history.pushState({}, "", url.toString());
        })
    }
  }
}

customElements.define('sort-container', SortContainer);
